import type { UploadQueueItem } from "../types";
import { UploadCard } from "./UploadCard";

interface UploadQueueProps {
  items: UploadQueueItem[];
  onChange: (id: string, changes: Partial<UploadQueueItem>) => void;
  onRemove: (id: string) => void;
  onRetry: (id: string) => void;
  busy: boolean;
}

export function UploadQueue(props: UploadQueueProps) {
  return (
    <section className="upload-queue" aria-label="Upload queue">
      <div className="upload-queue-heading">
        <div><span className="eyebrow">Upload queue</span><h2>{props.items.length} {props.items.length === 1 ? "clip" : "clips"} ready</h2></div>
        <span>{props.items.filter((item) => item.status === "success").length} complete</span>
      </div>
      <div className="upload-card-list">
        {props.items.map((item) => <UploadCard key={item.localId} item={item} {...props} />)}
      </div>
    </section>
  );
}
